module.exports = __webpack_public_path__ + "static/media/friendFinder.97059a40.png";